import React, { Fragment } from 'react';
import cx from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { cssTimeToMilliseconds } from 'helpers/cssTime';

const HasError = (Component) =>
  class HasError extends React.Component {
    state = {
      error: undefined,
    };

    static getDerivedStateFromProps(props, state) {
      if (!!props.error && props.error !== state.error) {
        return {
          error: props.error,
        };
      }
    }

    render() {
      const { error, invalid, className, ...rest } = this.props;
      const fast = '0.15s'; // from src/style/_variable.scss

      return (
        <Fragment>
          <Component
            className={cx(className, {
              input_error: error || invalid,
            })}
            {...rest}
          />

          <CSSTransition
            in={!!error}
            timeout={cssTimeToMilliseconds(fast)}
            classNames="input-error-text"
            appear
            mountOnEnter
            unmountOnExit
          >
            {(transitionState) => (
              <div className="input-error-text">
                {transitionState === 'entering' || transitionState === 'entered'
                  ? error
                  : this.state.error}
              </div>
            )}
          </CSSTransition>
        </Fragment>
      );
    }
  };

export default HasError;
